const HelpText = () => {
  return (
    <div className='flex flex-col gap-4'>
      <p>This page shows how credits have been used over time.</p>
      <p>
        Use the period selector to switch between short and long reporting ranges. Data is loaded in batches so results can start appearing
        without waiting for the full history to download.
      </p>
      <p>
        The table view includes filtering, sorting, and export. The chart view groups activity by event type so you can quickly see the main
        areas of spend. For prepay clients, credit purchases are also included so top-ups can be reviewed alongside spend.
      </p>
    </div>
  )
}

export default HelpText
